import { GET_SELLER_STAMPS, GET_SELLER_STAMPS_ERROR, GET_SELLER_STAMPS_SUCCESS } from './StampsSection.actions'

const stampsSectionState = {
  error: false,
  loading: true,
  stamps: []
}

/**
 * The seller stamps section's reducer.
 */
const stampsSectionReducer = (state = stampsSectionState, { payload, type }) => {
  switch (type) {
    case GET_SELLER_STAMPS: {
      return { ...state, loading: true }
    }
    case GET_SELLER_STAMPS_ERROR: {
      return { ...state, error: true, loading: false }
    }
    case GET_SELLER_STAMPS_SUCCESS: {
      return {
        ...state,
        loading: false,
        stamps: payload.stamps,
        error: false
      }
    }
    default: {
      return state
    }
  }
}

export default stampsSectionReducer
